<div class="page">
  <span class="eyebrow">Förvaring</span>
  <h1>Däckhotell &amp; Vinterförvaring</h1>

  <div class="panel">
    <p>Vi erbjuder förvaring på vårt däckhotell, här kan du tryggt förvara dina hjul i väntan på nästa säsong.</p>
    <p>Från 800 kr/säsong där däckskifte ingår.</p>
    <p>
      Du kan enkelt boka tid för däckskifte genom First Stops
      <a href="https://www.firststop.se/dack-sokresultat?subdomain=firststoposterbydackallserviceab&tyrechange=true&id=1476">bokningssystem</a>.
    </p>
    <a class="action action--primary book-btn" href="https://www.firststop.se/dack-sokresultat?subdomain=firststoposterbydackallserviceab&tyrechange=true&id=1476">
      Boka däckskifte
    </a>
  </div>
</div>
